import React from 'react';
import styled from 'styled-components';
import { Building2 as BuildingIcon, Globe, Mail, Users } from 'lucide-react';
import EllipsisMenu from '../Layout/EllipsisMenu';

const Card = styled.div`
  width: 100%;
  height: 120px;
  background: var(--bg-panel, #f7f9fa);
  border: 1.5px solid var(--border-color, #e0e4ea);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  display: flex;
  align-items: center;
  padding: 16px;
  box-sizing: border-box;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  position: relative;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  }
`;

const Logo = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: ${props => props.color || '#e3e7ef'};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-right: 16px;
  flex-shrink: 0;
  border: 1px solid var(--border-color, #e0e4ea);
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
`;

const Name = styled.div`
  font-weight: 700;
  font-size: 1.1rem;
  color: var(--text-main, #222);
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Website = styled.div`
  font-size: 0.9rem;
  color: var(--text-secondary, #555);
  margin-bottom: 2px;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Email = styled.div`
  font-size: 0.85rem;
  color: var(--text-tertiary, #888);
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const OrganizationCard = ({ organization, onEdit, onDelete }) => {
    if (!organization) return null;
  const { name, website, logo, color, verifiedEmail, teamMemberCount } = organization;

  const handleEdit = () => {
        if (onEdit) {
      onEdit(organization);
    }
  };

  const handleDelete = () => {
        if (onDelete) {
      onDelete(organization._id);
    }
  };

  return (
    <Card>
      <EllipsisMenu 
        onEdit={handleEdit}
        onDelete={handleDelete}
        showShare={false}
        showEdit={true}
        size={16}
      />
      <Logo color={color}>
        {logo ? (
          <img
            src={logo}
            alt={name || 'Organization'}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        ) : (
          <BuildingIcon size={24} color="#b0b8c9" />
        )}
      </Logo>
      <Content>
        <Name>{name || 'Unnamed Organization'}</Name>
        <Website><Users style={{marginRight: 4,opacity: 0.5}} size={12} />{teamMemberCount}</Website>
        {website && (
          <Website>
            <Globe size={12} />
            {website}
          </Website>
        )}
        {verifiedEmail && (
          <Email>
            <Mail size={12} />
            {verifiedEmail}
          </Email>
        )}
      </Content>
    </Card>
  );
};

export default OrganizationCard; 
